<template>
  <transition name="el-fade-in-linear">
    <div v-show="transitionshow">
      <!----------- 所有退货记录查询条件 -------------->
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
        <el-form-item style="width:19%" size="small">
          <el-date-picker v-model="order.date" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="orderisselect = true" :unlink-panels="false"
            style="width:100%"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="order.customerid" clearable filterable remote reserve-keyword :remote-method="getCustomer"
            :loading="customerLoading" placeholder="客户名称 / 简称 / 客户手机" style="width:100%" @change="changemycustomer">
            <el-option v-for="(item, index) in customerLists" :key="index" :label="item.showname"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="width:9%" size="small">
          <el-select v-model="order.account" clearable filterable placeholder="请选支付方式" @change="orderisselect = true"
            style="width:100%">
            <el-option v-for="(item, index) in accountLists" :key="index" :label="item.name" :value="item.id"
              v-if="item.id != ''"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="width:9%" size="small">
          <el-select v-model="order.status" clearable filterable placeholder="请选择订单状态" style="width:100%">
            <el-option v-for="(item, index) in statuslists" :key="index" :label="item.name" :value="item.id"
              v-if="item.id != ''"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item style="width:160px" size="small">
          <el-select v-model="order.status" clearable filterable placeholder="请选择是否含破损" style="width:100%">
            <el-option v-for="(item, index) in statuslists" :key="index" :label="item.name" :value="item.id"
              v-if="item.id != ''"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item style="width:14%" size="small">
          <el-input placeholder="请输入订单号" v-model="order.key" clearable style="width:100%"
            @change="orderisselect = true"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" icon="el-icon-search" @click="getOrderlists">查询</el-button>
          <el-button type="warning" icon="el-icon-plus" @click="addnews" :loading="orderaddLoading"
            v-if="actionauth.order_refund_add == 'true'">新增</el-button>
          <el-button type="warning" icon="el-icon-download" @click="exportrefund">导出</el-button>
        </el-form-item>
      </el-form>

      <div class="backborder2" style="margin-top:10px">
        <el-table :data="orderlists" style="width: 100%" v-loading="orderListLoading">
          <el-table-column type="expand">
            <template slot-scope="props">
              <div style="width:99%;color:#606266;padding:15px 0 15px 1%;font-size:13px">
                <span>备注：{{ props.row.note }}</span>
              </div>
              <el-table :data="props.row.goods">
                <el-table-column label="商品名称" min-width="250">
                  <template slot-scope="scope">
                    <div style="font-size:13px;line-height:23px;">{{ scope.row.name }}</div>
                    <div style="font-size:12px;line-height:23px;color:#999999">编号：{{ scope.row.number }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="所属销售单" min-width="150" align="center">
                  <template slot-scope="scope">
                    <div style="font-size:13px;width:100%">{{ scope.row.selldocuments }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="退货客户" min-width="150" align="center">
                  <template slot-scope="scope">
                    <div style="font-size:13px;width:100%">{{ scope.row.sellcustomer }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="销售单价" min-width="120" align="center">
                  <template slot-scope="scope">
                    <div style="font-size:13px">{{ scope.row.sell | CFMprice }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="数量" min-width="120" align="center">
                  <template slot-scope="scope">
                    <div style="font-size:13px">{{ scope.row.num }} {{ scope.row.unit }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="合计" min-width="120" align="center">
                  <template slot-scope="scope">
                    <div style="font-size:13px">{{ scope.row.amount | CFMprice }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="仓库" min-width="120" align="center">
                  <template slot-scope="scope">
                    <div style="font-size:13px">{{ scope.row.warehousename }}</div>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column label="退货单号" min-width="115">
            <template slot-scope="scope">
              <div style="font-size:14px;color:#409EFF;cursor: pointer;" @click="viewWithoutPrint(scope.row)">
                {{ scope.row.documents }}</div>
            </template>
          </el-table-column>
          <el-table-column label="退款金额" prop="total" min-width="120" align="center">
            <template slot-scope="scope">
              <div style="font-size:13px">{{ scope.row.total | CFMprice }}</div>
            </template>
          </el-table-column>
          <el-table-column label="退款账号" align="center" min-width="110">
            <template slot-scope="scope">
              <div style="font-size:13px">{{ scope.row.accountname == '未付款' ? '未付款' : scope.row.accountname }}</div>
            </template>
          </el-table-column>
          <el-table-column label="销售订单号" align="center" min-width="110">
            <template slot-scope="scope">
              <div style="font-size:13px">{{ scope.row.sell_documents }}</div>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" min-width="110">
            <template slot-scope="scope">
              <div style="font-size:13px" v-if="scope.row.status == 0">未审核</div>
              <div style="font-size:13px" v-if="scope.row.status == 1">已审核</div>
              <div style="font-size:13px" v-if="scope.row.status == 2">已完成</div>
            </template>
          </el-table-column>
          <el-table-column label="退款日期" align="center" min-width="110">
            <template slot-scope="scope">
              <div style="font-size:14px">{{ scope.row.paydate }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" min-width="200" fixed="right">
            <template slot-scope="scope">
              <el-button type="warning" size="small" round @click="showorder(scope.row)">确认 / 打印</el-button>
              <el-button type="warning" size="small" v-if="scope.row.status == 0 && scope.row.isdel == 0" round
                @click="editorder(scope.row)">编辑</el-button>
              <el-button type="" size="small" v-if="scope.row.status == 0 && scope.row.isdel == 0"
                @click="delCurrent(scope.row)" round>删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="orderPageSizeChange" @current-change="orderPageCurrentChange"
            :current-page="order.p" :page-sizes="[10, 20, 50]" :page-size="order.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="total_order_rows">
          </el-pagination>
          <!--分页end-->
        </div>
      </div>

      <!-------------------- 打印页 --------------------->
      <el-dialog title="确认打印" :visible.sync="printerDialog" width="80%" top="10vh">
        <div style="width:100%;text-align:right">
          <span v-if="printorderdetail.printnumber > 0" style="float:left;color:#E6A23C">本订单已打印
            {{ printorderdetail.printnumber }} 次</span>
          每页展示 <input type="text" v-model="rollpage" v-on:blur="changepagevlaue()"
            style="border-radius:5px;border:1px solid rgb(192, 196, 204);background-color:#fff;color:#606266;width:25px;height:30px;line-height:40px;padding:0 15px;margin-bottom:20px" />
          条
        </div>
        <div id="printContent" v-loading="printLoading">
          <div v-for="(iit, i) in prpage">
            <span style="float:right">{{ iit.id }}/{{ allprintpage }}</span>
            <DIV style="font-size:18px;padding-bottom:2px;" align="center" v-if="printsmodel.title == 1">
              <STRONG>{{ printsmodel.titlevalue }}</STRONG>
            </DIV>
            <ul class="titlelists">
              <li v-if="printsmodel.customer_name == 1">客户名称：{{ printorderdetail.customername }}</li>
              <li v-if="printsmodel.documents == 1">单据编号：{{ printorderdetail.documents }}</li>
              <li v-if="printsmodel.desc == 1">入库备注：{{ printorderdetail.note }}</li>
              <li v-if="printsmodel.contactphone == 1">客户电话：{{ printorderdetail.contactphone }}</li>
              <li v-if="printsmodel.accountname == 1">退款方式：{{ printorderdetail.accountName }}</li>
              <li v-if="printsmodel.deliverdate == 1">退款日期：{{ printorderdetail.paydate }}</li>
              <li v-if="printsmodel.address == 1" style="width:100%">客户地址：{{ printorderdetail.contactaddress }}</li>
            </ul>
            <TABLE border=1 cellSpacing=0 cellPadding=1 width="100%" style="border-collapse:collapse;font-size:15px"
              bordercolor="#333333">
              <thead>
                <TR class="contactcontent">
                  <TD>
                    <DIV align=center><b>关联客户</b></DIV>
                  </TD>
                  <TD>
                    <DIV align=center><b>关联销售单号</b></DIV>
                  </TD>
                  <TD v-if="printsmodel.number == 1">
                    <DIV align=center><b>编号</b></DIV>
                  </TD>
                  <TD v-if="printsmodel.product_name == 1">
                    <DIV align=center><b>品名</b></DIV>
                  </TD>
                  <TD v-if="printsmodel.product_spec == 1">
                    <DIV align=center><b>规格</b></DIV>
                  </TD>
                  <TD v-if="printsmodel.unit == 1">
                    <DIV align=center><b>单位</b></DIV>
                  </TD>
                  <TD v-if="printsmodel.num == 1">
                    <DIV align=center><b>数量</b></DIV>
                  </TD>
                  <TD v-if="printsmodel.sell == 1">
                    <DIV align=center><b>售价</b></DIV>
                  </TD>
                  <TD v-if="printsmodel.amount == 1">
                    <DIV align=center><b>小计</b></DIV>
                  </TD>
                  <TD v-if="printsmodel.warehourse == 1">
                    <DIV align=center><b>仓库</b></DIV>
                  </TD>
                  <TD v-if="printsmodel.refunddate == 1 && storageLocationStatus && batchStatus">
                    <DIV align=center><b>货位/批次</b></DIV>
                  </TD>
                  <TD v-if="printsmodel.refunddate == 1 && storageLocationStatus && !batchStatus">
                    <DIV align=center><b>货位</b></DIV>
                  </TD>
                </TR>
              </thead>
              <TBODY>
                <tr v-for="(item, index) in printorderdetail.goods" :key="index" class="contactcontent"
                  v-if="index >= prollpage[i]['startpage'] && index <= prollpage[i]['endpage']">
                  <TD v-text="item.sellcustomer" align="center"></TD>
                  <TD v-text="item.selldocuments" align="center"></TD>
                  <TD v-text="item.number" align="center" v-if="printsmodel.number == 1"></TD>
                  <TD v-text="item.name" style="padding-left:20px" v-if="printsmodel.product_name == 1"></TD>
                  <TD v-text="item.spec" align="center" v-if="printsmodel.product_spec == 1"></TD>
                  <TD v-text="item.unit" align="center" v-if="printsmodel.unit == 1"></TD>
                  <TD v-text="item.num" align="center" v-if="printsmodel.num == 1"></TD>
                  <TD align="center" v-if="printsmodel.sell == 1">{{ item.sell | CFMprice }}</TD>
                  <TD align="center" v-if="printsmodel.amount == 1">{{ item.amount | CFMprice }}</TD>
                  <TD v-text="item.warehousename" align="center" v-if="printsmodel.warehourse == 1"></TD>
                  <TD align="center" v-if="printsmodel.refunddate == 1 && storageLocationStatus && batchStatus">
                    <!-- <DIV align=center><b>货位/批次</b></DIV> -->
                     <div>{{ item.storage_location_code }}</div>
                     <div>
                        <span>{{ item.batch_sn }}</span>
                        <span v-if="item.start_date && item.end_date">[{{ item.start_date }} 至 {{ item.end_date }}] [{{ item.num }}]</span>
                     </div>
                  </TD>
                  <TD align="center" v-if="printsmodel.refunddate == 1 && storageLocationStatus && !batchStatus">
                    <!-- <DIV align=center><b>货位</b></DIV> -->
                    <div>{{ item.storage_location_code }}</div>
                  </TD>
                </tr>
                <tr v-if="iit.id == allprintpage">
                  <TD align="center" v-if="printsmodel.number == 1 || printsmodel.product_name == 1"><b>合计</b></TD>
                  <TD v-if="printsmodel.number == 1 && printsmodel.product_name == 1"></TD>
                  <TD v-if="printsmodel.product_spec == 1">&nbsp;</TD>
                  <TD v-if="printsmodel.unit == 1">&nbsp;</TD>
                  <TD v-if="printsmodel.num == 1">&nbsp;</TD>
                  <TD v-if="printsmodel.sell == 1">&nbsp;</TD>
                  <TD>&nbsp;</TD>
                  <TD>&nbsp;</TD>
                  <TD align="center" v-if="printsmodel.amount == 1">{{ printorderdetail.total | CFMprice }}</TD>
                  <TD v-if="printsmodel.warehourse == 1">&nbsp;</TD>
                  <!--<TD v-if="printsmodel.refunddate==1">&nbsp;</TD>-->
                </tr>
              </TBODY>
            </table>
            <TABLE border=0 cellSpacing=0 cellPadding=0 width="100%" style="margin-top:2px;font-size:15px">
              <TBODY>
                <TR>
                  <TD v-if="printsmodel.inputdate == 1">录单日期：{{ printorderdetail.inputdate }}</TD>
                  <TD v-if="printsmodel.total == 1">总计：{{ printorderdetail.total }}</TD>
                  <TD v-if="printsmodel.sysmanagername == 1">操作人：{{ printorderdetail.sysmanagername }}</TD>
                </TR>
              </TBODY>
            </TABLE>
            <div class="pageBreak"></div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer" v-if="!withoutPrint">
          <el-button size="small" @click="printerDialog = false">取 消</el-button>
          <el-button size="small" type="primary" @click="createnoSave" :loading="printorderLoading">打印</el-button>
          <el-button size="small" type="primary" @click="reStockRefundedGoods" v-if="printorderdetail.status == 0 && batchStatus">入库</el-button>
          <el-button size="small" type="danger" @click="verifyensureSave" :loading="verifyensureLoading"
            v-if="printorderdetail.status == 1">撤销审核</el-button>
          <el-button size="small" type="success" @click="finishSave" :loading="finishLoading"
            v-if="printorderdetail.status == 1">完成订单</el-button>
        </div>
      </el-dialog>

      <!---------------- 添加退货单页面 ------------------->
      <el-dialog title="添加退货" :visible.sync="addrefundDialog" width="90%" top="3vh">
        <el-tag type="danger">温馨提示：如选择了客户，则只能从该客户已销售出库的记录里选择商品退货；散客状态下可以添加任意商品进行退货</el-tag>
        <el-form :inline="true" class="demo-form-inline" ref="search" :model="search" style="margin-top:15px"
          size="medium">
          <el-form-item>
            <el-select v-model="create.customer" clearable filterable remote reserve-keyword
              :remote-method="getCustomer" @change="changecustomer()" :loading="customerLoading"
              placeholder="请输入客户名称 / 简称">
              <el-option v-for="(item, index) in customerLists" :key="index" :label="item.showname"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="请输入条形码" v-model="productquery.key" @keyup.enter.native="addDialogsingle">
              <template slot="prepend">查找</template>
              <el-button slot="append" icon="el-icon-search" @click="addDialogShow"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addDialogShow">添加退货商品</el-button>
            <el-button type="danger" icon="el-icon-delete" @click="delcart">清空购物车</el-button>
          </el-form-item>
        </el-form>

        <!----------------------------- 退货信息列表 ----------------------------------------------->
        <el-col :span="24">
          <template>
            <el-table :data="lists" v-loading="listsLoading" border show-summary>
              <el-table-column prop="number" label="编号" width="100"></el-table-column>
              <el-table-column prop="name" label="商品名称"></el-table-column>
              <el-table-column prop="spec" label="规格" width="80" align="center"></el-table-column>
              <el-table-column prop="unit" label="单位" width="80" align="center">
                <template slot-scope="scope">
                  <el-input size="medium" :value="scope.row.unit" readonly @focus="changeUnit(scope.row)"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="num" label="数量" width="80" align="center" current-row-key="getindex">
                <template slot-scope="scope">
                  <el-input size="medium" v-model="nums[scope.$index]"
                    @blur="changeNum(scope.$index, scope.row)"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="buy" label="进货价" width="100" align="center"></el-table-column>
              <el-table-column prop="total" label="小计" width="100" align="center">
                <template slot-scope="scope">
                  <el-input size="medium" v-model="totals[scope.$index]"
                    @blur="changeTotal(scope.$index, scope.row)"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="warehousename" label="仓库" width="120" align="center">
                <template slot-scope="scope">
                  <el-input size="medium" :value="scope.row.warehousename"
                    @focus="changeWarehouse(scope.$index, scope.row)"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="validity" label="生产日期" width="155" align="center">
                <template slot-scope="scope">
                  <el-date-picker size="medium" type="date" value-format="yyyy-MM-dd" placeholder="生产日期"
                    v-model="scope.row.validity" @change="changeValidity(scope.$index, scope.row)"
                    style="width:99%;"></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="50" align="center">
                <template slot-scope="scope">
                  <i class="el-icon-delete" @click="deltempCurrent(scope.row)"></i>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-col>

        <el-col :span="24">&nbsp;</el-col>
        <el-col :span="24">
          <div
            style="border:1px solid #ebeef5;background:#ebeef5;border-radius:6px;padding:20px;margin-bottom:20px;float:left">
            <el-form ref="create" :model="create" label-width="70px">
              <el-col :span="24">
                <el-col :span="6">
                  <el-form-item label="退款日期" style="width:90%">
                    <el-date-picker size="medium" type="date" placeholder="请选择付款日期" v-model="create.paydate"
                      style="width:99%;" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="退款帐号" style="width:90%">
                    <el-select size="medium" v-model="create.account" filterable placeholder="请选择付款帐号">
                      <el-option v-for="(item, index) in accountLists" :key="index" :label="item.name" :value="item.id"
                        v-if="item.id != ''"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="单据编号" style="width:90%">
                    <el-input size="medium" v-model="create.documents" placeholder="单据编号" :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="录单日期" style="width:90%">
                    <el-date-picker size="medium" type="date" value-format="yyyy-MM-dd" placeholder="请选择录单日期"
                      v-model="create.inputdate" style="width:99%;"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="入库备注" style="width:90%">
                    <el-input size="medium" placeholder="备注" v-model="create.note"></el-input>
                  </el-form-item>
                </el-col>
              </el-col>
            </el-form>
          </div>
        </el-col>

        <div slot="footer" class="dialog-footer" style="margin-top:10px">
          <el-button size="medium" @click="addrefundDialog = false">取 消</el-button>
          <el-button size="medium" type="primary" @click="createPrint" :loading="saveorderLoading">保存</el-button>
          <el-button size="medium" type="primary" @click="createandPrint"
            :loading="saveandprintLoading">保存并打印</el-button>
        </div>
      </el-dialog>

      <!----------------------- 批量添加商品模块 ----------------------->
      <el-dialog title="批量添加退货商品" :visible.sync="addDialog" width="60%" top="5vh">
        <el-form :inline="true" class="demo-form-inline" size="medium">
          <el-form-item style="width:15%">
            <el-select v-model="productquery.brandid" clearable filterable placeholder="按品牌" @change="selectbrand">
              <el-option label="不分品牌" value="0"></el-option>
              <el-option v-for="(item, index) in brandlists" :label="item.name" :value="item.id"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="width:15%">
            <el-cascader :options="categorylist" clearable v-model="productquery.catid" placeholder="请选择分类"
              @change="selectcate"></el-cascader>
          </el-form-item>
          <el-form-item ref="productquery" :model="productquery" style="width:18%">
            <el-input placeholder="商品名称 / 条形码 / 编号" clearable v-model="productquery.key"
              @keyup.enter.native="getProductList" @change="isnewselect = true"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getProductList">查询</el-button>
            <el-button type="danger" icon="el-icon-delete" @click="cleargoods">清空商品</el-button>
          </el-form-item>
        </el-form>

        <el-table ref="multipleTable" :data="productlists" style="width: 100%" v-loading="addListLoading"
          @row-click="handleSelectRow" @selection-change="addmultipleTable">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="number" label="编号" width="100"></el-table-column>
          <el-table-column prop="brandname" label="品牌" width="100" align="left"></el-table-column>
          <el-table-column prop="name" label="名称" align="left"></el-table-column>
          <el-table-column prop="spec" label="规格" width="150"></el-table-column>
          <el-table-column prop="num" label="可退数量" width="150" v-if="productquery.customerid > 0"
            align="center"></el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="productPageSizeChange" @current-change="productPageCurrentChange"
            :current-page="productquery.p" :page-sizes="[10, 20, 50]" :page-size="productquery.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="total_product_rows">
          </el-pagination>
          <!--分页end-->
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="addDialog = false">取 消</el-button>
          <el-button size="medium" type="primary" :loading="addProductLoading" @click="addSave">确认添加</el-button>
        </div>
      </el-dialog>

      <!---------------------------修改单位--------------------------->
      <el-dialog title="单位选择" :visible.sync="unitDialog">
        <el-table :data="unitlists" style="width: 100%" v-loading="unitListLoading">
          <el-table-column label="单位" prop="unit"></el-table-column>
          <el-table-column label="售价" prop="sell"></el-table-column>
          <el-table-column label="市场价" prop="market"></el-table-column>
          <el-table-column label="选择" width="80">
            <template slot-scope="scope">
              <el-button type="primary" size="small" circle icon="el-icon-check"
                @click="changeUnitSave(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <!--------------------------------修改单位end--------------------------->

      <!---------------------------修改仓库--------------------------->
      <el-dialog title="仓库选择" :visible.sync="wareDialog" width="40%">
        <el-table :data="wareHouseLists" style="width: 100%">
          <el-table-column label="仓库名称" prop="name"></el-table-column>
          <el-table-column label="选择" width="80">
            <template slot-scope="scope">
              <el-button type="primary" size="small" circle icon="el-icon-check"
                @click="changeWareSave(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <!---------------------------修改仓库--------------------------->


      <!---------------------------- 导出信息确认 ---------------------------->
      <el-dialog title="导出信息确认" :visible.sync="outputDialog" width="98%" top="5vh">
        <el-button size="medium" type="danger" @click="sureoutput"
          style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
        <div id="outputorder">
          <el-table :data="outlists" border v-loading="outlistsLoading">
            <el-table-column prop="inputdate" label="退款日期" width="90"></el-table-column>
            <el-table-column prop="documents" label="订单编号" width="90"></el-table-column>
            <el-table-column prop="sellcustomer" label="客户名称"></el-table-column>
            <el-table-column prop="district_name" label="所在区域"></el-table-column>
            <el-table-column prop="selldocuments" label="关联销售单号"></el-table-column>
            <el-table-column prop="goodsname" label="商品名称" align="center"></el-table-column>
            <el-table-column prop="spec" label="规格" align="center"></el-table-column>
            <el-table-column prop="number" label="编号" align="center"></el-table-column>
            <el-table-column prop="brandname" label="所属品牌" width="100" align="center"></el-table-column>
            <el-table-column prop="sell" label="售价" width="100" align="center"></el-table-column>
            <el-table-column prop="num" label="退货数量" width="100" align="center"></el-table-column>
            <el-table-column prop="amount" label="小计" width="100" align="center"></el-table-column>
            <el-table-column prop="selldiscount" label="原销售单折扣（100%）" width="100" align="center"></el-table-column>
            <el-table-column prop="unit" label="单位" width="100" align="center"></el-table-column>
            <el-table-column prop="buy" label="进货价" width="100" align="center"></el-table-column>
            <el-table-column prop="market" label="零售价" align="center"></el-table-column>
            <el-table-column prop="sell" label="批发价" align="center"></el-table-column>
            <el-table-column prop="warehousename" label="仓库名称" align="center"></el-table-column>
            <el-table-column prop="note" label="备注" align="center"></el-table-column>
            <el-table-column prop="status" label="信息状态" align="center"></el-table-column>
          </el-table>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="outputDialog = false">取 消</el-button>
          <el-button size="medium" type="danger" @click="sureoutput">确认导出</el-button>
        </div>
      </el-dialog>

      <!-- 入库 -->
      <checkInStore ref="checkInStoreRef" @confirm="confirmSelection"/>
    </div>
  </transition>
</template>

<script>
import checkInStore from '@/components/purchase/checkInStore.vue';

export default {
  components: { checkInStore },
  data() {
    return {
      url: this.GLOBAL.domain + "Refund/index",
      transitionshow: true,
      showPrintItem: {},
      actionauth: [],
      customerLists: [],
      customerLoading: false,
      warehouselists: [],
      accountLists: [],
      orderlists: [],
      orderListLoading: false,
      total_order_rows: 0,
      order: {
        act: 'getsellorderlists',
        token: this.$cookies.get('token'),
        date: '',
        customerid: '',
        customername: '',
        account: '',
        key: '',
        status: '',
        p: 1,
        rollpage: 10
      },

      prpage: [],
      prollpage: [],
      prtotal: 0,
      rollpage: 10,
      allprintpage: '',
      defaultwarehouseid: '', //默认发货仓库
      printsmodel: [],
      orderaddLoading: false,
      printerDialog: false,
      printLoading: false,
      printorderdetail: [],
      printorderLoading: false,
      addrefundDialog: false,
      /** 入库订单 **/
      listsLoading: false,
      lists: [],
      nums: [],
      totals: [],
      validitys: [],
      warehouses: [],
      create: {
        act: 'addrefund',
        token: this.$cookies.get('token'),
        paydate: new Date().getFullYear().toString() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
        lists: '',
        account: '',
        documents: '',
        customer: '',
        inputdate: new Date().getFullYear().toString() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
        node: '',
        nums: '',
        totals: '',
        validitys: new Date().getFullYear().toString() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
        warehouses: '',
        note: '',
        seller: '',
      },
      /** 批量添加退货商品 **/
      addDialog: false,
      productquery: {
        act: 'inventory',
        token: this.$cookies.get('token'),
        brandid: '',
        catid: '',
        warehouse: '',
        customerid: '',
        key: '',
        rollpage: 10, // 页大小
        p: 1
      },
      saveorderLoading: false,
      addDialog: false,
      brandlists: [],
      unitDialog: false,
      unitListLoading: false,
      changeunitid: '',
      unitlists: [],
      wareDialog: false,
      tempid: '',
      accountLists: [],
      totalPrice: 0,
      accountName: '',
      brandlists: [],
      categorylist: [],
      wareHouseLists: [],
      /** 搜索客户 **/
      search: {
        act: 'barcode',
        token: this.$cookies.get('token'),
        key: '',
        customer: ''
      },
      customerLoading: false,
      customerLists: [],
      printerDialog: false,
      productlists: [],
      multipleSelection: [],
      addListLoading: false,
      addProductLoading: false,
      total_product_rows: 0,
      isnewselect: false, //搜索条件是否改变，改变页数和每页条数要重置
      printsmodel: [],
      printlists: [],

      prpage: [],
      prollpage: [],
      prtotal: 0,
      rollpage: '',
      allprintpage: '',
      contactname: '',
      contactphone: '',
      contactaddress: '',
      orderisselect: false,
      saveandprintLoading: false,
      outputDialog: false,
      outlists: [],
      outlistsLoading: false,
      isselectall: true,
      sellerLists: [],
      statuslists: [{ id: '01', name: '未审核' }, { id: '1', name: '已审核' }, { id: '2', name: '已完成' }, { id: '3', name: '已撤销' }],
      verifyensureLoading: false,
      finishLoading: false,
      withoutPrint: false,
      batchStatus: false,
      storageLocationStatus: false
    }
  },


  filters: {
    /** 价格信息保留两位小数 **/
    CFMprice(value) {
      var price = parseFloat(value); //修剪去小数点后多余的0
      var numsobj = price.toString().split(".");	//判断小数点后有几位小数
      var result = 0.00;

      if (numsobj.length == 1) result = price.toFixed(2); //值为0时补充到2位
      if (numsobj.length > 1 && numsobj[1].length <= 2) result = price.toFixed(2); //值为小数点后只有1位小数时补充到2位
      if (numsobj.length > 1 && numsobj[1].length > 2) result = price; //小数点后的值超出2位时直接返回
      return result;
    }
  },



  mounted() {
    this.getactionauth(); //获取权限设置
    this.getOrderlists(); //获取销售订单列表
    this.getAccount(); //获取支付方式
    this.getprintsmodel(); //获取模板设置权限
    this.getWarehouse();  //仓库列表
    this.getCategoryList(); //获取分类列表
    this.getBrand(); //获取商品品牌
    this.getSeller(); //获取销售员列表
    this.batchStatus = localStorage.getItem('batchStatus') == 'true'
    this.storageLocationStatus = localStorage.getItem('storageLocationStatus') == 'true'
  },


  methods: {
    reStockRefundedGoods() {
      this.$refs.checkInStoreRef.openDialog(this.showPrintItem, 'Refund/index')
    },
    // 执行入库
    confirmSelection({row, type}) {
      this.$axios({
        url: this.GLOBAL.domain + 'Refund/index',
        method: 'post',
        data: {
          act: 'create_storage',
          token: this.$cookies.get('token'),
          id: row.id,
          type: type
        }
      }).then((res) => {
        if (res.Result === 0) {
          this.$message.success('入库成功');
          this.printerDialog = false
        }
      })
    },

    /** 获取操作功能权限 **/
    getactionauth() {
      var data = this.$cookies.get('actionauth');
      data = JSON.parse(data);
      this.actionauth = data;
    },

    /** 获取打印模板设置 **/
    getprintsmodel() {
      var resource = this.$resource(this.GLOBAL.domain + "Setting/index");
      resource.query({ act: 'getmodelsetting', id: 5, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.printsmodel = JSON.parse(Base64.decode(res.data.Data));
          this.rollpage = this.printsmodel.pagevalue < 1 ? 10 : this.printsmodel.pagevalue;
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 获取客户 **/
    getCustomer(query) {
      if (query !== '') {
        this.customerLoading = true;
        var resource = this.$resource(this.GLOBAL.domain + "Customer/index");
        resource.query({ act: 'lists', key: query, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.customerLoading = false;
          } else {
            this.customerLists = JSON.parse(Base64.decode(res.data.Data));
            this.customerLoading = false;
          }
        }).catch((res) => {
          //this.$message.error(this.GLOBAL.errortext);
          this.customerLoading = false;
        });
      }
    },

    changemycustomer(val) {
      var customername = '';
      this.customerLists.forEach(function (item, i) {
        if (val == item.id) customername = item.name;
      });
      this.order.customername = customername;
      this.orderisselect = true;
    },


    /** 获取银行帐户 **/
    getAccount() {
      var resource = this.$resource(this.GLOBAL.domain + "Account/index");
      resource.query({ act: 'lists', isdeposit: 1, isnopay: 1, token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.accountLists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 获取销售员 **/
    getSeller() {
      var resource = this.$resource(this.GLOBAL.domain + "Clerk/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.sellerLists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    //获取订单信息列表
    getOrderlists() {
      if (this.orderisselect == true) {
        this.order.p = 1;
        this.order.rollpage = 10;
      }

      this.orderListLoading = true;
      var resource = this.$resource(this.url);
      resource.save(this.order).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.orderListLoading = false;
        } else {
          this.orderlists = JSON.parse(Base64.decode(res.data.Data));
          this.total_order_rows = parseInt(res.data.count);
          this.orderListLoading = false;
          if (this.orderisselect == true) this.orderisselect = false;

          //打印完成刷新页面时重新加载参数
          if (this.$cookies.get('print_back_data_refund') && this.$cookies.get('print_back_data_refund') != '') {
            var data = this.$cookies.get('print_back_data_refund');
            data = JSON.parse(data);
            this.orderisselect = data.orderisselect;
            this.order = data.order;
            this.getCustomer(this.order.customername);
            this.$cookies.set('print_back_data_refund', '');
            this.getOrderlists();
          }

        }
      }).catch((res) => {
        this.orderListLoading = false;
      });
    },

    orderPageSizeChange(val) {
      this.order.rollpage = val;
      this.getOrderlists();
    },
    orderPageCurrentChange(val) {
      this.order.p = val;
      this.getOrderlists();
    },

    //展示打印确认页
    showorder(item) {
      this.showPrintItem = item;
      this.getprintdetail(item.id);
    },
    viewWithoutPrint(item) {
      this.getprintdetail(item.id, "onlyShow");
    },

    //编辑订单信息
    editorder(item) {
      this.$emit('listenchild', { name: '编辑退货订单', url: 'Refundedit', data: { id: item.id } });
    },

    //撤销订单
    verifyensureSave() {
      this.printerDialog = true;
      this.verifyensureLoading = true;
      var resource = this.$resource(this.url);
      resource.query({ act: 'cannelverify', token: this.$cookies.get('token'), id: this.printorderdetail.id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.verifyensureLoading = false;
        } else {
          this.verifyensureLoading = false;
          this.printerDialog = false;
          this.getOrderlists();
        }
      }).catch((res) => {
        this.verifyensureLoading = false;
      });
    },

    //完成订单信息
    finishSave() {
      this.printerDialog = true;
      this.finishLoading = true;
      var resource = this.$resource(this.url);
      resource.query({ act: 'finishSave_news', token: this.$cookies.get('token'), id: this.printorderdetail.id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.finishLoading = false;
        } else {
          this.finishLoading = false;
          this.printerDialog = false;
          this.getOrderlists();
        }
      }).catch((res) => {
        this.finishLoading = false;
      });
    },


    //获取订单打印信息
    getprintdetail(id, onlyShow) {
      this.printerDialog = true;
      this.printLoading = true;
      var resource = this.$resource(this.url);
      resource.query({ act: 'getprintinfos', token: this.$cookies.get('token'), id: id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.printLoading = false;
        } else {
          this.printorderdetail = JSON.parse(Base64.decode(res.data.Data));
          //对商品进行分页设置
          var number = this.rollpage; //系统设置的每页条数
          this.prtotal = this.printorderdetail.goods.length; //总条数
          this.prpage = [];
          this.prollpage = [];

          if (number >= this.prtotal) {
            this.prpage.push({ id: 1 });
            this.prollpage.push({ startpage: 0, endpage: number });
            this.allprintpage = 1;
          } else {
            var tnumber = parseInt(this.prtotal / number);
            var lnumber = this.prtotal % number;
            var index;
            var start;
            var end;
            lnumber > 0 ? tnumber++ : '';
            this.allprintpage = tnumber;
            for (var i = 0; i < tnumber; i++) {
              index = i + 1;
              this.prpage.push({ id: index });
              start = i * number;
              end = index * number - 1;
              this.prollpage.push({ startpage: start, endpage: end });
            }
          }
          this.printLoading = false;
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.printLoading = false;
      });
      if (onlyShow) {
        this.withoutPrint = true
      } else {
        this.withoutPrint = false
      }
    },


    /** 修改每页条数 **/
    changepagevlaue() {
      this.changepage();
    },

    /** 设置分页设置 **/
    changepage() {
      this.printLoading = true;
      var number = this.rollpage; //系统设置的每页条数
      this.prtotal = this.printorderdetail.goods.length; //总条数
      this.prpage = [];
      this.prollpage = [];

      if (number >= this.prtotal) {
        this.prpage.push({ id: 1 });
        this.prollpage.push({ startpage: 0, endpage: number });
        this.allprintpage = 1;
      } else {
        var tnumber = parseInt(this.prtotal / number);
        var lnumber = this.prtotal % number;
        var index;
        var start;
        var end;
        lnumber > 0 ? tnumber++ : '';
        this.allprintpage = tnumber;

        for (var i = 0; i < tnumber; i++) {
          index = i + 1;
          this.prpage.push({ id: index });
          start = i * number;
          end = index * number - 1;
          this.prollpage.push({ startpage: start, endpage: end });
        }
      }
      this.printLoading = false;
    },

    /** 订单信息打印 **/
    createnoSave() {
      this.printorderLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'updateprintnumber', token: this.$cookies.get('token'), id: this.printorderdetail.id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.printorderLoading = false;
        } else {
          this.printlocalpage(); //打印 
        }
      }).catch((res) => {
        this.printorderLoading = false;
      });
    },

    /** 打印当前页面 **/
    printlocalpage() {
      //设置打印完成后回调页面
      this.$cookies.set('returnurlids', 'Refund');
      //保留搜索前的数据
      var data = {};
      data.orderisselect = this.orderisselect;
      data.order = this.order;
      this.$cookies.set('print_back_data_refund', JSON.stringify(data));


      //设置打印信息
      var div_print = document.getElementById('printContent');
      var newStr = div_print.innerHTML;
      var oldStr = document.body.innerHTML;
      document.body.innerHTML = newStr;
      window.print();
      document.body.innerHTML = oldStr;
      location.reload();
    },

    /** 新增退款订单 **/
    addnews() {
      this.$emit('listenchild', { name: '新增退货订单', url: 'Refundadd' });
      //this.addrefundDialog=true;
      //this.getLists(); 
    },

    /** 获取退款信息 **/
    getLists() {
      this.listsLoading = true;
      var resource = this.$resource(this.url);
      resource.query({ act: 'refundlists', token: this.$cookies.get('token'), rollpage: 1000, id: this.create.id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.listsLoading = false;
        } else {
          this.lists = JSON.parse(Base64.decode(res.data.Data));
          this.listsLoading = false;
          //重置订单数据
          this.resetcreate();
          //获取单据编号
          this.getDocuments();
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.listsLoading = false;
      });
    },

    /** 重置退货单数据 **/
    resetcreate() {
      const _this = this;
      this.create.note = '';
      this.create.account = '';
      this.create.nums = this.nums;
      this.create.totals = '';
      this.create.warehouses = '';
      if (this.lists.length > 0) {
        this.lists.forEach(function (e, index) {
          _this.nums.splice(index, 1, e.num);
          _this.totals.splice(index, 1, e.total);
          _this.validitys.splice(index, 1, e.validity);
          _this.warehouses.splice(index, 1, e.warehousename);
        });
      }
    },


    /** 出库单号 **/
    getDocuments() {
      var resource = this.$resource(this.url);
      resource.query({ act: 'getxsdocuments', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.create.documents = result;
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 获取仓库列表 **/
    getWarehouse() {
      var resource = this.$resource(this.GLOBAL.domain + "Ware/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.wareHouseLists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 获取产品分类 **/
    getCategoryList() {
      var resource = this.$resource(this.GLOBAL.domain + "Product/index");
      resource.query({ act: 'getcatelist', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.categorylist = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 获取品牌 **/
    getBrand() {
      var resource = this.$resource(this.GLOBAL.domain + "Brand/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.brandlists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 品牌搜索（品牌发生变化时触发一次搜索） **/
    selectbrand() {
      this.isnewselect = true;
      this.getProductList();
    },
    /** 分类搜索（分类发生变化触发一次搜索） **/
    selectcate() {
      this.isnewselect = true;
      this.getProductList();
    },

    /** 添加退货商品 **/
    addDialogShow() {
      this.addDialog = true;
      this.multipleSelection = []; //清空已选中的商品
      this.productquery.customerid = this.create.customer;
      this.getProductList();
    },


    /** 产品信息列表 **/
    getProductList() {
      if (this.isnewselect == true) {
        this.productquery.p = 1;
        this.productquery.rollpage = 10;
      }

      this.addListLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.productquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.addListLoading = false;
        } else {
          this.productlists = JSON.parse(Base64.decode(res.data.Data));
          this.total_product_rows = parseInt(res.data.count);
          this.addListLoading = false;
          this.resetgoods();
        }

        if (this.isnewselect == true) this.isnewselect = false;
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.addListLoading = false;
        if (this.isnewselect == true) this.isnewselect = false;
      });
    },
    productPageSizeChange(val) {
      this.productquery.rollpage = val;
      this.getProductList();
    },
    productPageCurrentChange(val) {
      this.productquery.p = val;
      this.getProductList();
    },

    /** 点击单行选择产品 **/
    handleSelectRow(row, event, column) {
      var _this = this;
      var id = row.id;
      var isselect = 0;
      var number = 0;
      this.isselectall = false; //关闭点击单个勾选触发

      //勾选/取消勾选商品
      this.productlists.forEach(function (e, index) { if (e.id == id) _this.$refs.multipleTable.toggleRowSelection(_this.productlists[index]) });
      //添加、移除勾选的商品
      this.multipleSelection.forEach(function (e, index) { if (id == e.id) { isselect = 1; number = index; } });
      isselect == 1 ? this.multipleSelection.splice(number, 1) : this.multipleSelection.push(row);
      this.isselectall = true; //开启点击单个勾选触发
    },


    /** 选择商品信息  **/
    addmultipleTable(val) {
      if (this.isselectall == false) return false;
      var _this = this;
      var allids = [];
      var ids = [];
      var delids = [];
      var selectids = [];

      //获取当前列表的商品id
      this.productlists.forEach(function (e, index) { allids.push(e.id) });
      //获取选中的商品id
      val.forEach(function (e, index) { ids.push(e.id) });
      //筛选出没有勾选的商品id
      allids.forEach(function (e, index) { if (ids.indexOf(e) == -1) delids.push(e) });
      //获取当前选中的商品id
      this.multipleSelection.forEach(function (e, index) { selectids.push(e.id) });

      //添加选中的商品信息
      val.forEach(function (e, index) {
        if (selectids.indexOf(e.id) == -1) _this.multipleSelection.push(e);
      });

      //删除未选择的商品信息
      this.multipleSelection.forEach(function (e, index) {
        if (delids.indexOf(e.id) >= 0) _this.multipleSelection.splice(index, 1);
      });
    },


    /** 匹配勾选的商品信息 **/
    resetgoods() {
      var _this = this;
      var ids = [];

      this.multipleSelection.forEach(function (e, index) { ids.push(e.id) });
      setTimeout(function () {
        //已添加的商品默认勾选
        _this.productlists.forEach(function (e, index) {
          if (ids.indexOf(e.id) >= 0) _this.$refs.multipleTable.toggleRowSelection(_this.productlists[index]);
        });
      }, 100);
    },

    /** 清空已选中的商品信息 **/
    cleargoods() {
      this.multipleSelection = [];
      //清除勾选的商品信息
      this.$refs.multipleTable.clearSelection();
    },


    /** 确认添加商品进入购物车 **/
    addSave() {
      //获取仓库信息列表里的第一条仓库信息（入库缓存里不可以没有仓库信息）
      var warehouse = this.wareHouseLists[0]['id'];
      this.addProductLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'addproduct', productid: this.multipleSelection, warehouse: warehouse, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.addProductLoading = false;
        } else {
          this.$message.success("保存退货商品信息成功");
          this.addDialog = false;
          this.addProductLoading = false;
          this.getProductList();
          //this.getTotal();
          this.getLists();
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.addDialog = false;
        this.addProductLoading = false;
      });
    },


    /** 删除 **/
    deltempCurrent(item) {
      this.$confirm('此操作将删除 ' + item.name + ', 是否继续?', '提示', { type: 'warning' }).then(() => {
        // 向请求服务端删除
        var resource = this.$resource(this.url);
        resource.save({ act: 'del', id: item.id, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.$message.success('成功删除了' + item.name + '!');
            this.getLists();
          }
        }).catch((res) => {
          //this.$message.error(this.GLOBAL.errortext);
        });
      }).catch(() => {
        this.$message.info('已取消操作!');
      });
    },


    /** 清空购物车里的商品 **/
    delcart() {
      this.$confirm('您确定要清空购物车里的商品，继续?', '提示', { type: 'warning' }).then(() => {
        // 向请求服务端删除
        var resource = this.$resource(this.url);
        resource.save({ act: 'delAll', token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.$message.success('清空购物车商品信息成功!');
            this.getLists();
            //this.getTotal();
          }
        }).catch((res) => {
          //this.$message.error(this.GLOBAL.errortext);
        });
      }).catch(() => {
        //this.$message.info('已取消操作!');
      });
    },


    /** 修改单位名称 **/
    changeUnit(item) {
      this.unitDialog = true;
      this.unitListLoading = true;
      this.changeunitid = item.id;
      var resource = this.$resource(this.url);
      resource.query({ act: 'getunit', productid: item.productid, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.unitListLoading = false;
        } else {
          this.unitlists = JSON.parse(Base64.decode(res.data.Data));
          this.unitListLoading = false;
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.unitListLoading = false;
      });
    },


    /** 确认修改单位 **/
    changeUnitSave(item) {
      this.unitListLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'changeunit', id: item.id, customer: this.productquery.customerid, tempid: this.changeunitid, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.unitListLoading = false;
        } else {
          this.unitListLoading = false;
          this.getLists();
          //this.getTotal();
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.unitListLoading = false;
      });
      this.unitDialog = false;
    },


    /** 修改数量 **/
    changeNum(index, item) {
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'changenum', id: item.id, num: this.nums[index], customer: this.productquery.customerid, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.listLoading = false;
          this.getLists();
          //this.getTotal();
        } else {
          this.listLoading = false;
          this.getLists();
          //this.getTotal();
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.listLoading = false;
      });
    },


    /** 修改小计 **/
    changeTotal(index, item) {
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'changetotal', id: item.id, total: this.totals[index], token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.getLists();
          //this.getTotal();
          this.$message.error(res.data.Message);
          this.listLoading = false;
        } else {
          this.listLoading = false;
          this.getLists();
          //this.getTotal();
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.listLoading = false;
      });
    },


    /** 修改仓库信息 **/
    changeWarehouse(index, item) {
      this.tempid = item.id;
      this.wareDialog = true;
    },

    /** 修改生产日期 **/
    changeValidity(index, item) {
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'changecreatedate', id: item.id, validity: item.validity, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.listLoading = false;
        } else {
          this.listLoading = false;
          this.getLists();
        }
      }).catch((res) => {
        this.listLoading = false;
      });
    },


    /** 保存修改的仓库信息 **/
    changeWareSave(item) {
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'changeware', id: this.tempid, warehouse: item.id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.listLoading = false;
          this.wareDialog = false;
        } else {
          this.listLoading = false;
          this.getLists();
          this.wareDialog = false;
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.listLoading = false;
        this.wareDialog = false;
      });
    },

    /** 获取客户信息 **/
    getcustomerinfo(id) {
      var resource = this.$resource(this.url);
      resource.save({ act: 'getcustomerinfo', id: id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.contactname = result.name;
          this.contactphone = result.phone;
          this.contactaddress = result.address;
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 获取总价 **/
    getTotal() {
      var resource = this.$resource(this.url);
      resource.query({ act: 'gettotal', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.totalPrice = res.data.Message;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 确认退货 **/
    createPrint() {
      this.saveorderLoading = true;
      var resource = this.$resource(this.url);
      resource.save(this.create).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.saveorderLoading = false;
        } else {
          this.$message.success('退货入库成功！');
          this.saveorderLoading = false;
          this.addrefundDialog = false;
          this.getOrderlists(); //获取销售订单列表
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.saveorderLoading = false;
      });
    },


    /** 确认退货并打印 **/
    createandPrint() {
      this.saveandprintLoading = true;
      var resource = this.$resource(this.url);
      resource.save(this.create).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.saveandprintLoading = false;
        } else {
          this.$message.success('退货入库成功！');
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.saveandprintLoading = false;
          this.addrefundDialog = false;
          this.getprintdetail(result.id);
          this.getOrderlists(); //获取销售订单列表
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.saveandprintLoading = false;
      });
    },


    //删除单个
    delSingleCurrent(item) {
      this.$confirm('此操作将撤销 ' + item.name + ' 进货记录, 是否继续?', '提示', { type: 'warning' })
        .then(() => {
          // 向请求服务端删除
          var resource = this.$resource(this.GLOBAL.domain + "Storage/index");
          resource.save({ act: 'delsinglerecord', id: item.id, token: this.$cookies.get('token') })
            .then((res) => {
              if (res.data.Result > 0) {
                if (res.data.Result == '70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
              } else {
                this.$message.success('成功撤销了' + item.name + '!');
                this.getOrderlists(); //获取销售订单列表
              }
            }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
            });
        }).catch(() => {
          this.$message.info('已取消操作!');
        });
    },

    //删除
    delCurrent(item) {
      this.$confirm('此操作将撤销 ' + item.documents + ' 退货记录, 是否继续?', '提示', { type: 'warning' })
        .then(() => {
          // 向请求服务端删除
          var resource = this.$resource(this.url);
          resource.save({ act: 'delrecord', id: item.id, token: this.$cookies.get('token') })
            .then((res) => {
              if (res.data.Result > 0) {
                if (res.data.Result == '70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
              } else {
                this.$message.success('成功撤销了' + item.documents + '!');
                this.getOrderlists(); //获取销售订单列表
              }
            }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
            });
        })
        .catch(() => {
          this.$message.info('已取消操作!');
        });
    },

    //切换客户名称
    changecustomer() {
      var resource = this.$resource(this.url);
      resource.save({ act: 'changecustomer', token: this.$cookies.get('token'), customerid: this.create.customer }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.create.customer = '';
          this.productquery.customerid = '';
        } else {
          this.productquery.customerid = this.create.customer;
        }
      }).catch((res) => {

      });
    },

    //导出退货商品信息
    exportrefund() {
      this.outlistsLoading = true;
      this.outputDialog = true;
      var resource = this.$resource(this.GLOBAL.exportUrl + "Refund/index");
      resource.save({ act: 'getoutdata', date: this.order.date, customerid: this.order.customerid, account: this.order.account, key: this.order.key, token: this.$cookies.get('token'), isexport: 1 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.outlistsLoading = false;
        } else {
          this.outlists = JSON.parse(Base64.decode(res.data.Data));
          this.outlistsLoading = false;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.outlistsLoading = false;
      });
    },

    /** 确认导出订单信息 **/
    sureoutput() {
      require.ensure([], () => {
        var { export_json_to_excel } = require('../../vendor/Export2Excel');
        var tHeader = ['退款日期', '订单编号', '客户名称', '所在区域', '关联销售单号', '商品名称', '规格', '编号', '所属品牌', '售价', '退货数量', '小计', '原销售单折扣（100%）', '单位', '进货价', '零售价', '批发价', '仓库名称', '备注', '信息状态'];
        var filterVal = ['inputdate', 'documents', 'sellcustomer', 'district_name', 'selldocuments', 'goodsname', 'spec', 'number', 'brandname', 'sell', 'num', 'amount', 'selldiscount', 'unit', 'buy', 'market', 'sell', 'warehousename', 'note', 'status'];

        var list = this.outlists;
        var data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, '退货记录');
        this.outputDialog = false;
      })
    },

    //导出表格数据
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },




  }
}
</script>
<style>
.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder2 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 3% 1%
}

.titlelists {
  float: left;
  width: 100%;
  padding: 0;
  margin: 0
}

.titlelists li {
  float: left;
  width: 33.3%;
  font-size: 15px;
  list-style-type: none
}
</style>


// WEBPACK FOOTER //
// src/components/home/Refund.vue